module.exports = __webpack_public_path__ + "img/assurPlus_button.a6078632.png";